var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Dropdown, DropdownContent, DropdownTrigger, DropdownContext } from '../base';
import styles from './styles.module.scss';
import baseStyles from '../base/styles.module.scss';
import { Button } from '../../button';
import { withAliases } from '../../utils/with-aliases';
import Icon, { GLYPHS } from '../../../../../app/common/icon';
var Option = function (props) {
    return _jsx("div", { className: styles.option, children: props.children });
};
var Trigger = function (props) {
    var context = useContext(DropdownContext);
    var isDropdownOpen = context === null || context === void 0 ? void 0 : context.isOpen;
    return (_jsxs(Button.Outline, { className: baseStyles['trigger--button'], children: [_jsx("span", { children: props.label }), _jsx("div", { className: baseStyles['trigger--arrow'], children: _jsx(Icon, { glyph: GLYPHS.chevronDropdown, size: "micro", className: isDropdownOpen ? 'u-rotate-180' : '' }) })] }));
};
var DropdownWrapper = function (props) {
    var positionOptions = {
        side: props.side,
        sideOffset: props.sideOffset,
        align: props.align,
        alignOffset: props.alignOffset,
    };
    return (_jsxs(Dropdown, { className: props.className, children: [_jsx(DropdownTrigger, { children: _jsx(Trigger, { label: props.label }) }), _jsx(DropdownContent, __assign({}, positionOptions, { children: _jsx("div", { className: styles.content, children: props.children }) }))] }));
};
DropdownWrapper.defaultProps = {
    className: '',
    // eslint-disable-next-line react/default-props-match-prop-types
    sideOffset: 12,
    // eslint-disable-next-line react/default-props-match-prop-types
    align: 'end',
};
export var DropdownOutline = withAliases(DropdownWrapper, { Option: Option, Trigger: Trigger });
